export default __webpack_public_path__ + "static/media/photo4.08010399.jpg";